import React, { useState } from "react";
import { Dropdown, Menu, message } from "antd";
import moment from "moment";
import {
  FaChevronDown,
  FaUser,
  FaEllipsisV,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { APPOINTMENT_STATUS, formatDate } from "./constants";
import AppointmentActionForm from "./AppointmentActionForm";
import AppointmentStatusBadge from "./AppointmentStatusBadge";
import AppointmentFooter from "./AppointmentFooter";

const AppointmentItemCompact = ({ item, onEditAppointment }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [inputRemark, setInputRemark] = useState("");

  const isPast = item.appointment_date
    ? moment(item.appointment_date).isBefore(moment())
    : false;

  const status = item.appointment_status;

  const handleConfirmComplete = () => {
    if (!inputRemark.trim()) {
      message.error("กรุณาระบุผลการติดต่อ");
      return;
    }
    if (onEditAppointment) {
      onEditAppointment(item.id, item.appointment_date, item.appointment_note, {
        appointment_status: APPOINTMENT_STATUS.COMPLETE,
        appointment_remark: inputRemark.trim(),
      });
    }
    setActionType(null);
    setInputRemark("");
  };

  const handleConfirmCancel = () => {
    if (!inputRemark.trim()) {
      message.error("กรุณาระบุเหตุผลการยกเลิก");
      return;
    }
    if (onEditAppointment) {
      onEditAppointment(item.id, item.appointment_date, item.appointment_note, {
        appointment_status: APPOINTMENT_STATUS.CANCEL,
        appointment_remark: inputRemark.trim(),
      });
    }
    setActionType(null);
    setInputRemark("");
  };

  const handleCancelAction = () => {
    setInputRemark("");
    setActionType(null);
  };

  const actionMenu = (
    <Menu style={{ borderRadius: "6px", minWidth: "150px" }}>
      <Menu.Item
        key="complete"
        onClick={(e) => {
          if (e.domEvent) e.domEvent.stopPropagation();
          setInputRemark("");
          setActionType("complete");
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "12px",
            color: "#389e0d",
          }}
        >
          <FaCheck style={{ fontSize: "11px" }} />
          <span>เสร็จสิ้น</span>
        </span>
      </Menu.Item>
      <Menu.Item
        key="cancel"
        onClick={(e) => {
          if (e.domEvent) e.domEvent.stopPropagation();
          setInputRemark("");
          setActionType("cancel");
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "12px",
            color: "#cf1322",
          }}
        >
          <FaTimes style={{ fontSize: "11px" }} />
          <span>ยกเลิก</span>
        </span>
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      className={`appointment-card-item appointment-card-compact ${
        isPast ? "appointment-card-past" : "appointment-card-active"
      }`}
    >
      <div
        className="appt-compact-header cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
        title={isOpen ? "คลิกเพื่อย่อ" : "คลิกเพื่อขยายดูรายละเอียด"}
      >
        <div className="appt-compact-header-left">
          <span className="appt-compact-creator">
            นัดหมาย: {formatDate(item.appointment_date)}
          </span>
          <AppointmentStatusBadge
            status={status}
            isPast={isPast}
            style={{ marginLeft: "6px" }}
          />
          <span
            className="appt-compact-creator"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              marginLeft: "6px",
            }}
          >
            <FaUser style={{ fontSize: "11px", color: "#8c8c8c" }} />
            <span>{item.create_by || "-"}</span>
          </span>
        </div>

        <div
          className="appt-compact-header-right"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          {(status === APPOINTMENT_STATUS.WAITING || !status) && (
            <Dropdown
              overlay={actionMenu}
              trigger={["click"]}
              placement="bottomRight"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              <button
                type="button"
                className="btn-action-icon btn-action-more"
                title="ตัวเลือกเพิ่มเติม"
                onClick={(e) => e.stopPropagation()}
              >
                <FaEllipsisV style={{ fontSize: "11px" }} />
              </button>
            </Dropdown>
          )}

          <span
            className={`arrow-icon-transition ${isOpen ? "arrow-icon-rotated" : ""}`}
          >
            <FaChevronDown style={{ fontSize: "11px", color: "#8c8c8c" }} />
          </span>
        </div>
      </div>

      <AppointmentActionForm
        actionType={actionType}
        inputRemark={inputRemark}
        setInputRemark={setInputRemark}
        onCancel={handleCancelAction}
        onConfirmComplete={handleConfirmComplete}
        onConfirmCancel={handleConfirmCancel}
        className="mt-2"
        style={{ padding: "8px 12px" }}
      />

      {isOpen && !actionType && (
        <div className="appt-compact-body">
          <div className="appt-compact-detail">
            {item.appointment_note || "ไม่มีรายละเอียดเพิ่มเติม"}
          </div>

          {item.appointment_remark && (
            <div
              style={{
                fontSize: "11px",
                color:
                  status === APPOINTMENT_STATUS.CANCEL ? "#cf1322" : "#389e0d",
                marginTop: "4px",
                fontWeight: "500",
              }}
            >
              {status === APPOINTMENT_STATUS.CANCEL
                ? "เหตุผลที่ยกเลิก: "
                : "ผลการติดต่อ: "}
              <span style={{ color: "#262626" }}>
                {item.appointment_remark}
              </span>
            </div>
          )}

          <AppointmentFooter
            createBy={item.create_by}
            createDate={item.create_date}
            updateBy={item.update_by}
            updateDate={item.update_date}
          />
        </div>
      )}
    </div>
  );
};

export default AppointmentItemCompact;
